import { render, staticRenderFns } from "./NavOverlayCompactLayout.vue?vue&type=template&id=4bbb87b8&scoped=true&"
import script from "./NavOverlayCompactLayout.vue?vue&type=script&lang=js&"
export * from "./NavOverlayCompactLayout.vue?vue&type=script&lang=js&"
import style0 from "./NavOverlayCompactLayout.vue?vue&type=style&index=0&id=4bbb87b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb87b8",
  null
  
)

export default component.exports